import React from "react";
import { ArrowUpRight, ScanSearch, ArrowRight } from "lucide-react";
import { useI18n } from "@/i18n/I18nProvider";
import { useCta } from "@/context/SettingsContext";
import { Btn, Eyebrow, SectionTitle } from "@/components/ui-kit/Kit";
import { Reveal } from "@/components/motion/Reveal";
import { Section, Lead } from "@/components/ui-kit/Kit";

export const VerifyCta = () => {
  const { t } = useI18n();
  return (
    <Section className="py-24 sm:py-28" grid data-testid="verify-cta-section">
      <div className="grid gap-10 border border-navy/10 bg-white p-9 sm:p-14 lg:grid-cols-[1.2fr_1fr] lg:items-center">
        <Reveal>
          <Eyebrow>{t("home.verify.eyebrow")}</Eyebrow>
          <SectionTitle className="mt-5">{t("home.verify.title")}</SectionTitle>
          <Lead className="mt-4 max-w-md">{t("home.verify.sub")}</Lead>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="flex flex-col gap-3 lg:items-end">
            <Btn to="/verify" variant="navy" data-testid="verify-member-cta">
              <ScanSearch className="h-4 w-4" /> {t("cta.verifyMember")}
            </Btn>
            <Btn to="/verify" variant="outline" data-testid="verify-vendor-cta">
              {t("cta.verifyVendor")} <ArrowRight className="h-4 w-4" />
            </Btn>
          </div>
        </Reveal>
      </div>
    </Section>
  );
};

export const FinalCta = () => {
  const { t } = useI18n();
  const cta = useCta();
  return (
    <section
      className="relative overflow-hidden bg-navy-deep py-28 text-white grain sm:py-40"
      data-testid="final-cta-section"
    >
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 hairline-grid" />
      <div
        aria-hidden="true"
        className="pointer-events-none absolute left-1/2 top-1/2 h-[520px] w-[520px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-grn/12 blur-[140px]"
      />
      <div className="relative container text-center">
        <Reveal>
          <img
            src="/gpu-logo-t-256.webp"
            alt=""
            aria-hidden="true"
            loading="lazy"
            className="mx-auto mb-10 h-20 w-20 object-contain opacity-90 sm:h-24 sm:w-24"
          />
          <h2 className="mx-auto max-w-[22ch] font-display text-[clamp(2rem,5.4vw,4.2rem)] font-bold leading-[1.02] tracking-[-0.025em]">
            {t("home.finalCta.title")}
          </h2>
          <p className="mx-auto mt-7 max-w-xl text-sm text-white/60 sm:text-base">{t("home.finalCta.sub")}</p>
        </Reveal>
        <Reveal delay={0.12}>
          <div className="mt-11 flex flex-wrap items-center justify-center gap-4">
            <Btn href={cta.member_registration_url || "#"} external variant="solid" size="lg" data-testid="final-become-member">
              {t("cta.becomeMember")} <ArrowUpRight className="h-4 w-4" />
            </Btn>
            <Btn href={cta.vendor_registration_url || "#"} external variant="ghostLight" size="lg" data-testid="final-register-vendor">
              {t("cta.registerVendor")}
            </Btn>
          </div>
          <p className="mt-8 font-mono text-[10px] uppercase tracking-[0.2em] text-white/35">{t("common.appNote")}</p>
        </Reveal>
      </div>
    </section>
  );
};
